import { render, staticRenderFns } from "./CustomColors.vue?vue&type=template&id=607ca364&"
import script from "./CustomColors.vue?vue&type=script&lang=js&"
export * from "./CustomColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports